<div
  class="d-flex justify-content-start justify-content-sm-center center align-items-center flex-column min-h-100vh py-5 py-sm-4 py-lg-0">
  <div class="w-75">
    <div class="text-center mb-5">
      <img src="../../../../assets/images/app-logo.png" class="mt-5 mb-3" height="60px"/>
      <h4 class="font-poppins font-16 font-400 mb-5 text-center">The most advanced solution for Property Maintenance.
      </h4>
    </div>
    <div class="error-unauth d-flex justify-content-center text-center my-5 bg-light">
      <div class="error-msg">
        <h4 class="font-poppins font-20 font-500 text-center text-red font-semibold">Account in Review</h4>

        <div class="error-desc font-poppins font-13  font-medium">
          We are working on setting up your account and expect to complete this within 24 hours (but of course we will
          do
          this as soon as we can). If you have any questions in the meantime, please chat with us or send us an email to
          <a href="mailto:support@bricksandagent.com" class="primary-red">support@bricksandagent.com</a> We will be back
          in
          touch with your shortly. <br><span class="font-light">The team at Bricks + Agent.</span>
        </div>
      </div>
    </div>
    <div class="text-center font-poppins mt-5">
      <iframe src="https://player.vimeo.com/video/449129556?h=122e7337fe&title=0&byline=0&portrait=0" class="mt-4"
        width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen></iframe>
      <p class="mt-4"><a href="https://vimeo.com/449129556" target="_blank"><span
            class="bg-light py-2 px-3 rounded"><img src="../../../../assets/images/vimeo-tile.svg" height="14"
              class="me-2" /><span>Bricks and Agent | Maintenance</span></span></a> from <a
          href="https://vimeo.com/user86917407" target="_blank"><span class="bg-light py-2 px-3 rounded"><img
              src="../../../../assets/images/vimeo-tile.svg" height="14" class="me-2" /><span>Bricks +
              Agent</span></span></a> on <a href="https://vimeo.com" target="_blank"><span
            class="bg-light py-2 px-3 rounded"><img src="../../../../assets/images/vimeo-tile.svg" height="14"
              class="me-2" /><span>Vimeo</span></span></a></p>
    </div>
    <div class="text-center mt-5 font-poppins ">
      <p class="text-center"><a href="https://courses.bricksandagent.com/" target="_blank"><span
            class="bg-light py-2 px-3 rounded"><img src="../../../../assets/images/app-logo.svg" height="14"
              class="me-2" /><span>Courses</span></span></a></p>

      <div class="text-center my-5 font-poppins ">
        <div class="form-group">
          <button class="btn btn-danger font-14 px-5 py-3 border-0" (click)="backToSignIn()">Back to Sign in</button>
        </div>
      </div>
    </div>
  </div>